import React from 'react';
import { useGetEventRecurringSeries } from '../../hooks';

const RecurringEventBadge = ({ eventId, seriesId }) => {
  const { data: seriesData } = useGetEventRecurringSeries(
    { eventId },
    { enabled: !!eventId && !!seriesId }
  );

  return (
    seriesId &&
    seriesData?.eventIds && (
      <div className="rounded-full bg-primary-100 p-2 flex items-center justify-center gap-1 text-primary-700">
        <img src="/img/icons/sync-blue.svg" className="w-[24px]" />
        <p className="text-base font-normal">
          {`${seriesData.eventIds.indexOf(eventId) + 1} of ${
            seriesData.eventIds.length
          }`}
        </p>
      </div>
    )
  );
};

export default RecurringEventBadge;
